
import { Component, Vue } from "vue-property-decorator";
// @ is an alias to /src

@Component
export default class SiteLogo extends Vue {
  private name = "SiteLogo";
}
